module.exports = __webpack_public_path__ + "static/ditoTitle.74131612.png";